import api from 'api'
import { CACHE_TAG_FOLLOW_UP_LIST } from '../cacheTagTypes'
import { withIdTag } from 'utils/cache'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    getCustomerFollowUpById: build.query({
      query: body => ({ url: '/api/account/follow-up/view', method: 'POST', body }),
      providesTags: (result, error, arg) => withIdTag(CACHE_TAG_FOLLOW_UP_LIST, arg?.id),
    }),
  }),
})

export const { useLazyGetCustomerFollowUpByIdQuery } = extendedApi
